import { type UsePaginationResponse } from '../components/Pagination/hooks/usePagination';

export const calcIndex = (pagination: UsePaginationResponse, index: number) =>
	pagination.totalCount - (pagination.curPage - 1) * pagination.listCount - index;
